import { createSlice } from '@reduxjs/toolkit';

import {
  addToCompareAPI,
  getCompareListAPI,
  removeFromCompareAPI,
} from '../actions/CustomerCompareAction';

import { fetchHeaderFooterData } from './CustomerGlobalSlice';

interface CompareState {
  compareItems: any[];
  totalCompareProducts: number;
  loading: boolean;
}

const initialState: CompareState = {
  compareItems: [],
  totalCompareProducts: 0,
  loading: false,
};

export const CustomerCompareSlice = createSlice({
  name: 'customerCompare',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // FETCH
      .addCase(getCompareListAPI.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCompareListAPI.fulfilled, (state, action) => {
        const data = action.payload?.data || action.payload;
        state.loading = false;
        if (Array.isArray(data)) {
          state.compareItems = data;
          state.totalCompareProducts = data.length;
        } else {
          state.compareItems = data?.compare_products || [];
          state.totalCompareProducts = data?.total_compare_products ?? state.compareItems.length;
        }
      })
      .addCase(getCompareListAPI.rejected, (state) => {
        state.loading = false;
      })
      // update qty from global slice
      .addCase(fetchHeaderFooterData.fulfilled, (state, action) => {
        const data = action.payload;
        state.totalCompareProducts = data?.total_compare_products ?? 0;
      })
      // REMOVE
      .addCase(removeFromCompareAPI.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeFromCompareAPI.fulfilled, (state, action) => {
        const data = action.payload?.data || action.payload;
        const removedId = action.meta.arg;
        state.loading = false;
        state.compareItems = state.compareItems.filter((item) => {
          const product = item?.product || item;
          const productId = product?.id || product?._id;
          return productId !== removedId;
        });
        if (action.payload?.alreadyRemoved) {
          // it was not in the server's list, so there is nothing to subtract from the count
        } else if (Array.isArray(data)) {
          state.totalCompareProducts = data.length;
        } else {
          state.totalCompareProducts =
            data?.total_compare_products ?? Math.max(0, state.totalCompareProducts - 1);
        }
      })
      .addCase(removeFromCompareAPI.rejected, (state) => {
        state.loading = false;
      })

      // ADD
      .addCase(addToCompareAPI.pending, (state) => {
        state.loading = true;
      })
      .addCase(addToCompareAPI.fulfilled, (state, action) => {
        const data = action.payload?.data || action.payload;
        state.loading = false;
        if (Array.isArray(data)) {
          state.totalCompareProducts = data.length;
        } else {
          state.totalCompareProducts = data?.total_compare_products ?? state.totalCompareProducts;
        }
      })
      .addCase(addToCompareAPI.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default CustomerCompareSlice.reducer;
